import { useEffect, useRef } from 'react';

interface IOptions {
  threshold: number;
  rootMargin: string;
  root: HTMLElement | null;
}

const useInterSectionObserver = (
  callback: (isIntersecting: boolean) => void,
  options: IOptions,
) => {
  const elementRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(e => {
      callback(e[0].isIntersecting);
    }, options);

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
  }, []);

  return { elementRef };
};

export default useInterSectionObserver;
